export default __webpack_public_path__ + "static/media/photo 6.edac050a.jpg";